<template>
  <!-- <dv-full-screen-container> -->
  <div id="index" :style="bgImage" ref="appRef">
    
    <div style="
        height: 100% ;
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 100%;
      ">
      <div style="width: 100%;height: 80px;"></div>
      <div class="bg">
        <Shouye v-if="activeComponents == 'Shouye'" :activeComponents="activeComponents"
          @changeActiveComponents="changeActiveComponents" :temp="temp"></Shouye>
        <resourceStatus v-if="activeComponents == 'resourceStatus'"></resourceStatus>
        <ecologicalCondition v-if="activeComponents == 'ecologicalCondition'"></ecologicalCondition>
        <pestStatus v-if="activeComponents == 'pestStatus'"></pestStatus>
      </div>
    </div>

    <div class="header">
      <div class="Header-container">
        <Header :headerTitle="headerTitle" :homeVoice="homeVoice" :resourceVoice="resourceVoice" :ecologicalVoice="ecologicalVoice" :biologicalVoice="biologicalVoice" :activeComponents="activeComponents"
          @changeActiveComponents="changeActiveComponents" />
      </div>
    </div>
 
    <span  class="home-button" v-if="homeButton=='show'">
      <el-button @click="skipHome" icon="el-icon-s-home" circle></el-button>
    </span>
    <el-dialog :visible.sync="dialogVisible" width="20%" :before-close="handleClose">
      <div ref="qrcode" style="margin:0 auto;"></div>
      <div style="text-align: center;color: red;margin-top: 10px;">该设备未绑定,请扫描二维码</div>
    </el-dialog>
    <!-- <div>
        <Shouye></Shouye>
      </div> -->
    
  </div>
<!-- </dv-full-screen-container> -->
</template>

<script>
import drawMixin from "./fixer";
import { Map, View, Feature } from "ol";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { XYZ, Vector as VectorSource, TileWMS } from "ol/source";
import "ol/ol.css";
import CFG from "@/config/config.json";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import Header from "./header";
import Shouye from "./components/shouye-view";
import resourceStatus from "./components/resource-status-view";
import ecologicalCondition from "./components/ecological-condition-view";
import pestStatus from "./components/pest-status-view";

import * as api from "@/api/large-screen";
import * as cloudScreenApi from "@/api/cloud-screen";

import QRCode from 'qrcodejs2'

export default {
  components: {
    Treeselect,
    Header,
    Shouye,
    resourceStatus,
    ecologicalCondition,
    pestStatus,
  },
  // mixins: [drawMixin],
  data() {
    return {
      featureOverlayDeviceMap: null,
      lineFeatureOverlay: null,
      map: null,
      user: this.$store.state.res_data,
      taskNameList: [],
      pointList: [],
      queryParams: {
        taskId: "",
        type: "",
        orgId: null,
        status: "",
        year: "",
        typeOfPest: "",
      },
      drawer: false,
      direction: "rtl",
      drawerInfo: {},
      listQuery: {
        size: 9999999,
        current: 1,
        total: 10,
      },
      dispalyObj: {
        display: "inline",
      },

      token: "Bearer" + " " + this.$store.state.token,

      district: null,
      polygon: null,
      markers: [],
      type: "map",
      // type: "image",
      width: 0,
      bgImage: {},
      activeComponents: "",
      headerTitle: "",
      homeVoice:null,
      resourceVoice:null,
      ecologicalVoice:null,
      biologicalVoice:null,
      conf: null,
      temp: null,
      systemSid: "",
      params: null,
      organization: null,
      dialogVisible: false,
      qrcode: null,
      timerId: null,
      count: 0, // 用于计数的数据属性
      homeButton:'show'
    };
  },
  created() {
    // console.log(drawMixin)
    // console.log(this.mixins)
    // console.log(this.$route.query)
    // bindwindowSizeChanged(()=>{
    //     this.$forceUpdate()
    // })
  },
  watch: {
    "$route.meta.title": {
      handler(val) {
        if (val == "数字地图") {
          console.log("aaaaaaaaa-----------");
          this.drawer = false;
          // this.map = null
          setTimeout(() => {
            this.initMap();
            this.getXzqh();
            this.findTaskNameByMap();
            this.findOrganizationById();
          }, 500);
        }
      },
      deep: true,
    },
  },
  methods: {
    skipHome(){
      this.$router.push("/cloud_screen/" + this.$route.params.systemSid);
    },
    handleClose() {
      this.dialogVisible = false

    },
    generateQRCode() {
      this.$nextTick(item => {
        if (this.qrcode != null) {
          this.qrcode.clear() // 清除原来的二维码
        }
        console.log(this.$refs)
        console.log(this.$refs.qrcode)
        this.qrcode = new QRCode(this.$refs['qrcode'], {
          width: 256,
          height: 256,
          text: this.$route.params.systemSid
        })

      })

    },

    changeActiveComponents(value) {
      console.log(value, "---------------")
      this.activeComponents = value;
      this.headerTitle = null
      this.changeHeaderTitle()
    },
    changeHeaderTitle() {
      console.log(this.activeComponents == 'resourceStatus')
      console.log(1)
      if (this.activeComponents == 'Shouye') {
        console.log(2)
        if (this.$route.query && JSON.stringify(this.$route.query) != '{}') {
          if (this.$route.query["homeTitle"]) {
            this.headerTitle = this.$route.query["homeTitle"];
          } else {
            this.headerTitle = (this.conf && this.conf.homeTitle)
              ? this.conf.homeTitle
              : this.organization.label + "草原一张图";
          }
        } else {
          console.log(3)
          this.headerTitle = (this.conf && this.conf.homeTitle)
            ? this.conf.homeTitle
            : this.organization.label + "草原一张图";
        }
        this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["homeVoice"])?this.$route.query["homeVoice"]:this.conf["homeVoice"]

      } else if (this.activeComponents == 'resourceStatus') {
        console.log(4)
        if (this.$route.query && JSON.stringify(this.$route.query) != '{}') {
          console.log(6)
          if (this.$route.query["resourceTitle"]) {
            this.headerTitle = this.$route.query["resourceTitle"];
          } else {
            this.headerTitle = (this.conf && this.conf.resourceTitle)
              ? this.conf.resourceTitle
              : this.organization.label + "资源状况一张图";
          }

        } else {
          console.log(7)
          this.headerTitle = (this.conf && this.conf.resourceTitle)
            ? this.conf.resourceTitle
            : this.organization.label + "资源状况一张图";

        }
        this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["resourceVoice"])?this.$route.query["resourceVoice"]:this.conf["resourceVoice"]
      } else if (this.activeComponents == 'ecologicalCondition') {
        if (this.$route.query && JSON.stringify(this.$route.query) != '{}') {
          if (this.$route.query["ecologicalTitle"]) {
            this.headerTitle = this.$route.query["ecologicalTitle"];
          } else {
            this.headerTitle = (this.conf && this.conf.ecologicalTitle)
              ? this.conf.ecologicalTitle
              : this.organization.label + "生态状况一张图";
          }

        } else {
          this.headerTitle = (this.conf && this.conf.ecologicalTitle)
            ? this.conf.ecologicalTitle
            : this.organization.label + "生态状况一张图";

        }
        this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["ecologicalVoice"])?this.$route.query["ecologicalVoice"]:this.conf["ecologicalVoice"]
      } else if (this.activeComponents == 'pestStatus') {
        if (this.$route.query && JSON.stringify(this.$route.query) != '{}') {
          if (this.$route.query["biologicalTitle"]) {
            this.headerTitle = this.$route.query["biologicalTitle"];
          } else {
            this.headerTitle = (this.conf && this.conf.biologicalTitle)
              ? this.conf.biologicalTitle
              : this.organization.label + "有害生物状况一张图";
          }

        } else {
          this.headerTitle = (this.conf && this.conf.biologicalTitle)
            ? this.conf.biologicalTitle
            : this.organization.label + "有害生物状况一张图";
        }
        this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["biologicalVoice"])?this.$route.query["biologicalVoice"]:this.conf["biologicalVoice"]
      }
      console.log(this.headerTitle)

    },
    initMap() {
      // console.log("initmap========")
      this.map = new Map({
        target: "index",
        layers: [
          new TileLayer({
            source: new XYZ({
              crossOrigin: "anonymous",
              url: "https://webst04.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}",
            }),
            name: "baseLayer1",
            opacity:0.5
          }),
        ],
        view: new View({
          projection: "EPSG:4326", //使用这个坐标系
          center: [96.90903585532304, 33.39698851449892],
          zoom: 10.5,
        }),
      });
    },
  },
  async mounted() {
    // let device = await cloudScreenApi.getByDevice(this.$route.params.systemSid);
    // if (device.resp_code == "10000") {
    //   if (!device.data) {
    //     this.dialogVisible = true
    //     this.generateQRCode()
    //     this.timerId = setInterval(async () => {
    //       let device = await cloudScreenApi.getByDevice(this.$route.params.systemSid);
    //       if (device.data) {

    //         clearInterval(this.timerId);
    //         this.dialogVisible = false
    //         location.reload();
    //       }
    //     }, 5000);
    //   } else {

    //     let data = await cloudScreenApi.getConfig(this.$route.params.systemSid);
    //     if (data.resp_code == "10000") {
    //       this.conf = data.data;
    //     }
    //     console.log(this.$route.query);
    //     if (this.$route.query["type"]) {
    //       this.activeComponents = this.$route.query["type"];
    //     } else {
    //       this.activeComponents = "Shouye";
    //     }
    //     console.log(this.$route.query["type"])
    //     cloudScreenApi.getTemp(this.$route.params.systemSid).then((res) => {
    //       if (res.resp_code == "10000") {
    //         this.temp = res.data;
    //         console.log("-----------------", this.temp)
    //         if (this.temp && this.temp.backdropImage) {
    //           this.type = "image";
    //         } else {
    //           this.type = "map";
    //         }
    //         if (this.type == "image") {
    //           this.bgImage = {
    //             "background-image": 'url(/api-e/'+this.temp.backdropImage+')',
    //             "background-size": "cover",
    //             "background-position": "center center",
    //           };
    //         } else {
    //           this.bgImage = {};
    //           this.initMap();
    //         }
    //       }
    //     });

    //     cloudScreenApi.getOrgByDevice(this.$route.params.systemSid).then((res) => {
    //       if (res.resp_code == "10000") {
    //         this.organization = res.data;
    //         if (this.$route.query && JSON.stringify(this.$route.query) != '{}') {
    //           console.log("aaaaaaaaaaa")
    //           if (this.$route.query["type"] && this.$route.query["type"] == "Shouye") {

    //             if (this.$route.query["homeTitle"]) {
    //               this.headerTitle = this.$route.query["homeTitle"];
    //             } else {
    //               this.headerTitle = (this.conf && this.conf.homeTitle)
    //                 ? this.conf.homeTitle
    //                 : this.organization.label + "草原一张图";
    //             }



    //           } else if (this.$route.query["type"] && this.$route.query["type"] == "resourceStatus") {

    //             if (this.$route.query["resourceTitle"]) {
    //               this.headerTitle = this.$route.query["resourceTitle"];
    //             } else {
    //               this.headerTitle =(this.conf && this.conf.resourceTitle)
    //                 ? this.conf.resourceTitle
    //                 : this.organization.label + "资源状况一张图";
    //             }

    //           } else if (this.$route.query["type"] && this.$route.query["type"] == "ecologicalCondition") {

    //             if (this.$route.query["ecologicalTitle"]) {
    //               this.headerTitle = this.$route.query["ecologicalTitle"];
    //             } else {
    //               this.headerTitle = (this.conf && this.conf.ecologicalTitle)
    //                 ? this.conf.ecologicalTitle
    //                 : this.organization.label + "生态状况一张图";
    //             }

    //           } else if (this.$route.query["type"] && this.$route.query["type"] == "pestStatus") {

    //             if (this.$route.query["biologicalTitle"]) {
    //               this.headerTitle = this.$route.query["biologicalTitle"];
    //             } else {
    //               this.headerTitle = (this.conf && this.conf.biologicalTitle)
    //                 ? this.conf.biologicalTitle
    //                 : this.organization.label + "有害生物状况一张图";
    //             }

    //           }

    //         } else {
    //           this.headerTitle = (this.conf && this.conf.homeTitle)
    //             ? this.conf.homeTitle
    //             : this.organization.label + "草原一张图";

    //           console.log(this.headerTitle)
    //         }
    //       }
    //     });

    //   }
    // }
    if(this.$route.query && this.$route.query.homeButton){
          this.homeButton="hide"==this.$route.query.homeButton?'hide':'show'
        }
    let data = await cloudScreenApi.getConfig(this.$route.params.systemSid);
    if (data.resp_code == "10000") {
      this.conf = data.data;
    }
    console.log(this.$route.query);
    if (this.$route.query["type"]) {
      this.activeComponents = this.$route.query["type"];
    } else {
      this.activeComponents = "Shouye";
      // this.activeComponents = "resourceStatus";
    }
    console.log(this.$route.query["type"])
    cloudScreenApi.getTemp(this.$route.params.systemSid).then((res) => {
      if (res.resp_code == "10000") {
        this.temp = res.data;
        console.log("-----------------", this.temp)
        if (this.temp && this.temp.backdropImage) {
          this.type = "image";
        } else {
          this.type = "map";
        }
        if (this.type == "image") {
          this.bgImage = {
            "background-image": 'url(/api-e' + this.temp.backdropImage + ')',
            "background-size": "cover",
            "background-position": "center center",
          };
        } else {
          this.bgImage = {};
          this.initMap();
        }
      }
    });

    cloudScreenApi.getOrgByDevice(this.$route.params.systemSid).then((res) => {
      if (res.resp_code == "10000") {
        this.organization = res.data;
        if (this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["type"]) {
          console.log("aaaaaaaaaaa")
          if (this.$route.query["type"] && this.$route.query["type"] == "Shouye") {

            if (this.$route.query["homeTitle"]) {
              this.headerTitle = this.$route.query["homeTitle"];
            } else {
              this.headerTitle = (this.conf && this.conf.homeTitle)
                ? this.conf.homeTitle
                : this.organization.label + "草原一张图";
            }
            this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["homeVoice"])?this.$route.query["homeVoice"]:this.conf["homeVoice"]
          } else if (this.$route.query["type"] && this.$route.query["type"] == "resourceStatus") {

            if (this.$route.query["resourceTitle"]) {
              this.headerTitle = this.$route.query["resourceTitle"];
            } else {
              this.headerTitle = (this.conf && this.conf.resourceTitle)
                ? this.conf.resourceTitle
                : this.organization.label + "资源状况一张图";
            }
            this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["resourceVoice"])?this.$route.query["resourceVoice"]:this.conf["resourceVoice"]
          } else if (this.$route.query["type"] && this.$route.query["type"] == "ecologicalCondition") {

            if (this.$route.query["ecologicalTitle"]) {
              this.headerTitle = this.$route.query["ecologicalTitle"];
            } else {
              this.headerTitle = (this.conf && this.conf.ecologicalTitle)
                ? this.conf.ecologicalTitle
                : this.organization.label + "生态状况一张图";
            }
            this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["ecologicalVoice"])?this.$route.query["ecologicalVoice"]:this.conf["ecologicalVoice"]
          } else if (this.$route.query["type"] && this.$route.query["type"] == "pestStatus") {

            if (this.$route.query["biologicalTitle"]) {
              this.headerTitle = this.$route.query["biologicalTitle"];
            } else {
              this.headerTitle = (this.conf && this.conf.biologicalTitle)
                ? this.conf.biologicalTitle
                : this.organization.label + "有害生物状况一张图";
            }
            this.homeVoice=(this.$route.query && JSON.stringify(this.$route.query) != '{}' && this.$route.query["biologicalVoice"])?this.$route.query["biologicalVoice"]:this.conf["biologicalVoice"]

          }

        } else {
          console.log(this.conf)
          this.headerTitle = (this.conf && this.conf.homeTitle)
            ? this.conf.homeTitle
            : this.organization.label + "草原一张图";
            this.homeVoice=this.conf["homeVoice"]
          console.log(this.headerTitle)
        }
      }
    });
  },
};
</script>

<style scoped lang="scss">

.home-button /deep/  .el-button--default:hover {
  background:rgba(255, 255, 255,0.6) !important;
}
.home-button /deep/ .el-button{
  font-size: 1.8vw;
}
.home-button /deep/ .el-button--default{
  background:rgba(255, 255, 255,0.8) !important;
  color: #5c5959 !important;
  border: none;

}

.home-button /deep/ .el-button.is-circle {
    padding: 5px;
}

/deep/.ol-overlaycontainer-stopevent {
  z-index: 2 !important;
}

.image_title {
  text-align: center;
  color: #00ffff;
  font-size: 2vw;
  height: 40px;
  line-height: 40px;
  font-weight: 500;
}

.title_icon {
  transform: rotate(90deg);
  font-weight: 700;
  color: #00ffff;
}

.resource-title {
  color: #fff;
  font-size: 2vw;
  height: 40px;
  line-height: 40px;
  margin-top: -10px;
  font-weight: 500;
}

.image_base {
  width: 100%;
  height: 100%;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/large-screen-img/ditu.png");
  background-size: cover;
  background-position: center center;
}

// .image_base {
//     border: 1px solid blue;
//     position: absolute;
//     margin-top: 0px;
//     height: 100%;
//     width: 100%;
//     margin: 0px auto;
//     background: url("../../assets/large-screen-img/ditu.png") no-repeat;
//     background-size: cover;
// }

// .image_base{
//     width: 100%;height: 100%;
//             background-image: url("../../assets/large-screen-img/ditu.png");
//   background-position: center;
//   background-repeat: no-repeat;

// }

.Header-container {
  width: 100%;
  height: 100%;
}

.header {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 80px;
  line-height: 80px;

  background-position: center;
  background-repeat: no-repeat;
  /*background-size: "contain"*/
}

.home-button {
  z-index: 1;
  position: absolute;
  left: 1%;
  bottom: 0;
  right: 0;
  height: 80px;
  line-height: 80px;

  background-position: center;
  background-repeat: no-repeat;
  width: 0;
  /*background-size: "contain"*/
}

@import "./index.scss";
</style>
